/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import { useOpportunityId } from 'domain/shared/opportunity';
import { usePresaleOutputService } from 'domain/shared/presale';
import PresaleOutputForm from 'domain/sales/opportunity/presale/output/form/PresaleOutputForm';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';

const UpdatePresaleOutputForm = ({ getDataFunc, onCancel, ...props }: any) => {
  const opportunityId = useOpportunityId();
  const { updateOutput, getValidationSchema } = usePresaleOutputService();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={(id, values) => updateOutput(opportunityId, id, values)}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <PresaleOutputForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdatePresaleOutputForm;
